

import {computed, defineComponent, onMounted, ref} from "vue";
import WhiteBoxMain from '@/components/WhiteBoxMain.vue';
import {useRoute} from 'vue-router';
import {
  getPartnerReviewCompleteRequest,
  getReviewQuiz,
  PartnerReviewQuestionResource,
  PartnerReviewQuizResource,
  apiPartnerReviewQuestion, PartnerReviewQuestionRequest, apiSendSummary,
} from '@/api/partnerReviewApi';
import AdminReviewSentRequestQuestionAnswer, {
  QuestionAcceptRejectEdit
} from '@/components/AdminReviewSentRequestQuestion.vue';
import BaseButton from '@/components/BaseButton.vue';
import LoadingSvg from '@/assets/img/LoadingSvg.vue';
import TheModal from '@/components/TheModal.vue';
import useModal from '@/hooks/useModal';
import {formatInTimeZone} from 'date-fns-tz';
import router from '@/router';
import {requestApproved} from '@/core/constants';
import { notification} from 'ant-design-vue';
import SendSummaryBox from '@/components/SendSummaryBox.vue';
export type QuestionResponseState = 'edited' | 'rejected' | 'accepted';
export default defineComponent( {
  name: 'PartnerReviewSingleQuiz',
  components: {
    SendSummaryBox,
    TheModal, LoadingSvg, BaseButton, AdminReviewSentRequestQuestionAnswer, WhiteBoxMain,
  },
  setup() {
    const route = useRoute();
    const {
      params: { id },
    } = route;

    const questions = ref<Array<PartnerReviewQuestionResource & {user_answer?: string | string[], is_answer_changed?: boolean }>>([]);
    const entireServerResponse = ref<PartnerReviewQuizResource | null>(null);
    const editingQuestionId = ref<number | null>(null);
    const confirmModal = useModal(false);

    const userResponseTypes = ref({
      edited: 0,
      approved: 0,
      rejected: 0,
    })

    const questionResponsesState = ref<Record<string, QuestionResponseState>>({})

    const setQuestionResponseState = (id: number, data: QuestionResponseState) => {
      questionResponsesState.value[id] = data;
    }

    const haveAnswers = computed(() => {
      console.log(questions.value.filter(q => q.is_answer_changed === true));
      return questions.value.filter(q => q.is_answer_changed === true).length > 0
    })

    onMounted(() => {
      getReviewQuiz(id as string)
      .then(response => {
        questions.value = response.partner_review_questions;
        entireServerResponse.value = response;
      })
    })

    const isQuestionActive = (questionId: number) =>
      editingQuestionId.value !== null && questionId === editingQuestionId.value;

    const handleValueUpdate = (questionId: number, val: string) => {
      const questionIX = getQuestionIndexById(questionId);
      questions.value[questionIX].user_answer = val;
    };

    const getQuestionIndexById = (questionId: number): number => {
      let questionIndex = -1;
      questions.value.forEach((question, ix) => {
        if (question.id === questionId) {
          questionIndex = ix;
        }
      });
      return questionIndex;
    };

    const handleReviewQuestion = (id: number, questionAcceptRejectEdit: QuestionAcceptRejectEdit, cb: () => void) => {
      const payload: PartnerReviewQuestionRequest['answer'] = {};

      questions.value.forEach((question) => {
        if( id === question.id) {
          let data: {
            answer_id?: number,
            value?: any,
            review_state?: 0 | 1,
            review_note?: string,
          } = {};

          if(questionAcceptRejectEdit.state === 'edit') {
            data.value = question.user_answer
          } else if(questionAcceptRejectEdit.state === 'reject') {
            data.answer_id = question.partner_answer.id;
            data.review_note = questionAcceptRejectEdit.rejectReason
            data.review_state = 0;
          } else if(questionAcceptRejectEdit.state === 'accept') {
            data.answer_id = question.partner_answer.id
            data.review_state = 1;
          }
          payload[question.id] = data
        }
      });
      if(!entireServerResponse.value) throw new Error('No Data');

      apiPartnerReviewQuestion({
        answer: payload,
        request_uuid: entireServerResponse.value.partner_review_request.uuid,
      }).then(() => {
         const questionIX = getQuestionIndexById(id);
         questions.value[questionIX].is_answer_changed = false;

         if(questionAcceptRejectEdit.state === 'edit') {
           notification.success({
             message: 'Request Successfully Edited',
             description: 'You have successfully edit a new request.',
           });
           userResponseTypes.value.edited += 1;

         } else if(questionAcceptRejectEdit.state === 'reject') {
           notification.success({
             message: 'Request Successfully Rejected',
             description: 'You have successfully reject a request.',
           });
           userResponseTypes.value.rejected += 1;
         }  else if(questionAcceptRejectEdit.state === 'accept') {
           notification.success({
             message: 'Request Successfully Accepted',
             description: 'You have successfully accept a new request.',
           });
           userResponseTypes.value.approved += 1;
         }

         cb();

       })
    }

    const completeReview = () => {
      if(!entireServerResponse.value) throw new Error('No Data')
      apiSendSummary({request_uuid: entireServerResponse.value.partner_review_request.uuid}).then(res => {
        router.push({
          name: requestApproved,
        });
      }).catch(error => {
        confirmModal.close();
        notification.error({
          message: 'Error!',
          description: error.response.data.message,
          duration: 5000,
        })
      })

      // const payload: Record<number, {
      //   id?: number,
      //   value?: string | string[]
      // }> = {};
      // const keys = Object.keys(questionResponsesState.value);
      // questions.value.forEach((question) => {
      //   if(keys.indexOf(question.id.toString()) !== -1) {
      //     console.log('asdasdas')
      //     let data: {
      //       id?: number,
      //       value?: string | string[]
      //     } = {};
      //     if(questionResponsesState.value[question.id] === 'edited') {
      //       data.value = question.user_answer
      //     } else if(questionResponsesState.value[question.id] === 'rejected') {
      //       data.id = question.original_answer.id
      //     }  else if(questionResponsesState.value[question.id] === 'accepted') {
      //       data.id = question.partner_answer.id
      //     }
      //     payload[question.id] = data
      //   }
      // });
      // if(!entireServerResponse.value) throw new Error('No Data')
      // getPartnerReviewCompleteRequest({
      //   answer: payload,
      //   request_uuid: entireServerResponse.value.partner_review_request.uuid,
      // })
      // .then(() => {
      //   notify({
      //     title: "Review completed successfully.",
      //     type: 'success',
      //     duration: 5000,
      //     closeOnClick: true,
      //   });
      //   router.push({
      //     name: requestApproved,
      //   });
      // })
      // .catch(error => {
      //   confirmModal.close();
      //   notify({
      //     title: error.response.data.message,
      //     type: 'error',
      //     duration: 5000,
      //     closeOnClick: true,
      //   });
      // })
    };

    const formatDate = (date: string) => {
      // eslint-disable-next-line max-len
      return formatInTimeZone(new Date(date), Intl.DateTimeFormat().resolvedOptions().timeZone, 'MMM d, yyyy HH:MM');
    };


    return {
      questions,
      isQuestionActive,
      handleValueUpdate,
      completeReview,
      confirmModal,
      entireServerResponse,
      formatDate,
      questionResponsesState,
      setQuestionResponseState,
      haveAnswers,
      handleReviewQuestion,
      userResponseTypes,
    }
  },

});
